/** QC2 name alone is not completion — status must advance past Allocated. */
export const isAllocationQc2Complete = (status?: string | null): boolean => {
  if (!status) return false;
  const s = status.trim();
  return (
    s === "Ready to Upload" ||
    s.startsWith("Uploaded") ||
    s.startsWith("Completed")
  );
};

export const isAllocationWorkflowActive = (status?: string | null): boolean => {
  if (!status) return false;
  const s = status.trim();
  return s === "Allocated" || s.startsWith("Unhold by");
};
